/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/books.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
const SendMailRejection = () => {
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '비회원', value: 0},
    {title: '회원', value: 1},
    {title: '교사', value: 2},
    {title: '직원', value: 3}
  ];
  return (
    <main className="com_container p_send_mail_rejection">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_9">
            문자/메일 보내기
            <span className="bar"></span>
            <span className="point_txt">수신거부 목록</span>
          </h2>
          <div className="com_btn_wrap">
            <button className="com_btn s orange " >
              수신 거부 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="이름 검색" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <table className="com_board_list">
              <colgroup>
                <col width="70" />
                <col width="70" />
                <col width="274" />
                <col width="274" />
                <col width="274" />
                <col width="274" />
                <col width="274" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>
                    <input type="checkbox" id="chkAll" className="com_chk" />
                    <label htmlFor="chkAll"></label>
                  </th>
                  <th>거부일</th>
                  <th>비고</th>
                  <th>이름</th>
                  <th>전화번호</th>
                  <th>메일</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <BtnLike/>
                  </td>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>2022, 08, 25</td>
                  <td>홍보학생</td>
                  <td>김학생123</td>
                  <td>010-1234-1234</td>
                  <td>@</td>
                </tr>
                {[...Array(8)].map((i, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>
                      <input type="checkbox" id="chk00" className="com_chk" />
                      <label htmlFor="chk00"></label>
                    </td>
                    <td>2022, 08, 25</td>
                    <td>홍보학생</td>
                    <td>김학생123</td>
                    <td>010-1234-1234</td>
                    <td>@</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="com_board_list__bottom">
              <button className="com_btn black xs">선택한 항목 수신거부 해지</button>
              <div className="paging_wrap">
                <Paging />
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="form_radio_wrap">
                <div className="form_tit">수신거부 직접 입력</div>
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">홍보학생</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">학생 교사</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">학부모</label>
                  <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">직원</label>
                </div>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="이름 검색" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                  <button className="com_btn orange s">등록</button>
                </article>
              </section>
            </div>
            <div className="form_wrap">
              <dl>
                <dt>이름</dt>
                <dd>
                  <input type="text" className="input" />
                </dd>
              </dl>
              <dl>
                <dt>전화번호</dt>
                <dd>
                  <input type="text" className="input" />
                </dd>
              </dl>
              <dl>
                <dt>메일</dt>
                <dd>
                  <input type="text" className="input" />
                </dd>
              </dl>
              <button className="com_btn orange s">등록</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default SendMailRejection;
